export function camelCaseToWords(s) {
  if (!s) return;
  const result = s.replace(/([A-Za-z0-9])([A-Z])/g, "$1 $2");
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export function uriSafeTitle(title) {
  if (!title) return;
  return encodeURIComponent(
    title
      .replaceAll(" ", "-")
      .normalize("NFD")
      .replace(/[^a-zA-Z0-9-_]/g, "")
  );
}
